<template>
  <div>
    <Header :isactive='6' :ischunrk='true' :key="new Date().getTime()"/>
    <div style="height: 60px;"></div>
    <div id="banner">
      <img src="@/assets/image/banner-rule.jpg" alt="">
    </div>
    <div id="contact-us">
      <div class="us-content">
        <div class="title-content">
          <p class="trans">TERMS OF SERVICE</p>
          <p class="title">服务条款</p>
        </div>
        <div class="us-list">
          <p class="title">服务条款的接受</p>
          <p class="text">用户一经完成注册过程，即视为完全接受本协议的所有条款。</p>
          <p class="title">服务说明</p>
          <p class="text">优我科华为用户提供移动应用广告的相关服务。优我科华保留不经事先通知因维修、升级或其他原因暂停本网站服务任何部分的权利。优我科华保留变更服务的权利。</p>
          <p class="title">用户行为</p>
          <p class="text-item">用户在使用优我科华提供的服务时，不得发布含有以下内容的信息或应用：</p>
          <p class="text-item">1. 违反国家宪法所确定的基本原则的；</p>
          <p class="text-item">2. 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
          <p class="text-item">3. 损害国家荣誉和利益的；</p>
          <p class="text-item">4. 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
          <p class="text-item">5. 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
          <p class="text-item">6. 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
          <p class="text-item"> 7. 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的</p>
          <p class="text-item">8. 侮辱或者诽谤他人，侵害他人合法权益的；</p>
          <p class="text-item">9. 含有法律、行政法规禁止的其他内容的。</p>
          <p class="text-item">10. 用户不得用任何不正当手段损害本平台其他用户及本平台的利益及声誉。</p>
          <p class="text">11. 用户违反上述规定的一条或多条，本平台有权随时解除合作。</p>
          <p class="title">免责声明</p>
          <p class="text-item">用户请理解并接受：</p>
          <p class="text-item">1. 优我科华不担保所提供的服务一定能满足用户的要求，也不担保服务不会受中断。对服务的及时性、安全性、准确性不做担保。</p>
          <p class="text">2.用户下载或通过优我科华取得的任何信息资料取决于用户自己，所存在的风险将完全由自己承担；因使用优我科华服务而产生的一切后果也由用户自己承担，优我科华对用户不承担任何责任。</p>
          <p class="title">服务的修改、中断和终止</p>
          <p class="text-item">优我科华将尽力提供最好的服务，并在发生任何修改或中断服务时即时通知用户，但是优我科华保留以下权利：</p>
          <p class="text-item">1. 必要时修改或中断服务而不需通知用户的权利。</p>
          <p class="text">2. 对于所有服务的中断或终止而造成的任何损失，无需对用户或任何第三方承担任何责任。</p>
          <p class="title">其他</p>
          <p class="text">服务条款最终解释权和修改权归西安优我科华视觉科技有限公司所有。</p>
        </div>
      </div>
    </div>
    <Footer/>
    <Top/>
  </div>
</template>

<script>
import Header from '@/components/Header/index.vue'
import Footer from '@/components/Footer/index.vue'
import Top from '@/components/Top/index.vue'

export default {
  components: {'Header': Header, 'Footer': Footer, 'Top': Top},
  data() {
    return {
      ad5: false,
      ad6: false,
      ad7: false,
      ad8: false
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
}

</script>
<style lang='scss' scoped>
$active: #13c2c2;
$width: 1200px;
$banner-height: 632px;
$font: 14px;
$trans: 0.25;
$opacity: 0.85;
$time-height: 110px;

#contact-us {
  padding: 120px 0px;

  .us-content {
    width: $width;
    margin: 0 auto;

    .us-list {
      margin-top: 60px;

      p {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.85);
        line-height: 30px;
      }

      .title {
        font-weight: 600;
      }

      .text {
        margin-bottom: 36px;
      }

      .title-text {
        margin-bottom: 48px;
      }

      .text-item {
        margin: 8px 0px;
      }

      .email-msg {
        opacity: 0.65;
      }

      .email-img {
        margin: 6px 0px;
      }
    }
  }
}

#banner {
  width: 100%;
  /* height: 482px; */

  img {
    width: 100%;
    /* min-width: 1920px; */
    display: block;
  }
}

.title-content {
  text-align: center;

  .title {
    font-size: 30px;
    height: 36px;
    line-height: 36px;
  }

  .icon {
    margin: 10px auto;
    height: 2px;
    width: 24px;
    background: $active;
  }

  .trans {
    font-size: $font;
    opacity: $trans;
  }
}
</style>
